<template>
  <div>
    <div class="table-responsive-sm mt-4">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" class="" style="width: 15%">Travel</th>
            <th scope="col" class="text-right" style="width: 15%">Hrs or Miles Claimed</th>
            <th scope="col" class="text-right">Hrs or Miles Processed</th>
            <th scope="col" class="text-right">UOM</th>
            <th scope="col" class="text-right">Rate - Pull Rate</th>
            <th scope="col" class="text-right">Total Claimed</th>
            <th scope="col" class="text-right">Total Processed</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in travelRows" :key="index">
            <td>
              <input type="text" v-model="row.travel" disabled style="width:99% !important" :id="'travel_' + index"
                :name="'travel' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="number" v-model="row.values_claimed" style="width:99% !important"
                :id="'values_claimed_' + index" :name="'values_claimed' + index" class="vgt-input text-right"
                v-on:keyup="calculateClaimAmount(index)">
            </td>
            <td>
              <input type="text" v-model="row.values_processed" disabled style="width:99% !important"
                :id="'values_processed_' + index" :name="'values_processed' + index" class="vgt-input text-right">
            </td>
            <td>
              <v-select v-model="row.selectedUom" :id="'uom' + index" :name="'uom' + index" label="text"
                :options="row.uom" placeholder="Select UOM" class='custom-ci-auto-search contract-data'
                @change="updateTravelRate(index)">
              </v-select>
            </td>
            <td>
              <input type="text" v-model="row.factor" disabled style="width:99% !important" :id="'factor_' + index"
                :name="'factor' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" v-model="row.charges_claimed" disabled style="width:99% !important"
                :id="'charges_claimed_' + index" :name="'charges_claimed' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" v-model="row.charges_processed" disabled style="width:99% !important"
                :id="'charges_processed_' + index" :name="'charges_processed' + index" class="vgt-input text-right">
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <button type="button" v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvOtherChargesTravelRowsSection",
  props: ["lineItemData", "claimId", "hideEditSection"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    rows: [],
    travelRows: [],
    otherChargesTotalTable: [],
    location_id: null,
    zip: null,
    phone_no: null,
    city_id: null,
    state: null,
    street_address: null,
    travelRate: 0,
    hourRate: 0,
  }),
  created() {
    this.populateData();
  },
  methods: {
    populateData() {
      for (let i = 0; i < this.lineItemData[0].rows.length; i++) {
        this.rows.push(this.lineItemData[0].rows[i]);
      }
      for (let i = 0; i < this.lineItemData[0].travelRows.length; i++) {
        this.travelRows.push(this.lineItemData[0].travelRows[i]);
      }
      for (let i = 0; i < this.lineItemData[0].otherChargesTotalTable.length; i++) {
        this.otherChargesTotalTable.push(this.lineItemData[0].otherChargesTotalTable[i]);
      }
      this.location_id = this.lineItemData[0].location_id;
      this.zip = this.lineItemData[0].zip;
      this.phone_no = this.lineItemData[0].phone_no;
      this.city_id = this.lineItemData[0].city_id;
      this.state = this.lineItemData[0].state;
      this.street_address = this.lineItemData[0].street_address;
      this.hourRate = this.lineItemData.laborRate;
      this.travelRate = this.lineItemData.distanceRate;
      this.getTravelHourRate(this.hourRate, this.travelRate);
    },
    getTravelHourRate(hourRate, travelRate) {
      this.travelRate = "$" + this.amountFormat(travelRate);
      for (const row of this.travelRows) {
        if (row.travel == "Travel Hours") {
          row.factor = "$" + this.amountFormat(hourRate);
        } else {
          row.factor = this.travelRate;
        }
      }
    },
    calculateClaimAmount(index) {
      const travelRow = this.travelRows[index];
      travelRow.charges_claimed = 0;
      const factorAmount = this.amountFormatToFloat(travelRow.factor);
      const claimed = travelRow.values_claimed;
      travelRow.charges_claimed = factorAmount * claimed;
      travelRow.charges_claimed = this.amountFormat(travelRow.charges_claimed);
      this.calculateTotalClaimAmount();
    },
    calculateTotalClaimAmount() {
      this.otherChargesTotalTable[0].claimed_amount = 0
      for (const travelRow of this.travelRows) {
        this.otherChargesTotalTable[0].claimed_amount = this.otherChargesTotalTable[0].claimed_amount + this.amountFormatToFloat(travelRow.charges_claimed);
      }
    },
    updateTravelRate(index) {
      this.travelRows[index].factor = this.travelRate;
    },
    prepareDataForUpdating() {
      const lineItemData = {
        rows: this.rows,
        travelRows: this.travelRows,
        otherChargesTotalTable: this.otherChargesTotalTable,
        state: this.state,
        city_id: this.city_id,
        street_address: this.street_address,
        location_id: this.location_id,
        zip: this.zip,
        phone_no: this.phone_no,
      };
      return lineItemData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/other-charges-travel-rows",
          type: "POST",
          data: {
            lineItemData: lineItemData,
            claimId: self.claimId,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("travel_rows");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },

  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvOtherChargesTravelRowsSection.vue